import { render, staticRenderFns } from "./LogDrawer.vue?vue&type=template&id=524b973c&scoped=true"
import script from "./LogDrawer.vue?vue&type=script&lang=ts"
export * from "./LogDrawer.vue?vue&type=script&lang=ts"
import style0 from "./LogDrawer.vue?vue&type=style&index=0&id=524b973c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b973c",
  null
  
)

export default component.exports